import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        mt: 'auto',
        py: 6,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Network Computers
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Your trusted online store for high-quality computer accessories,
              mobile gadgets, storage devices, gaming essentials, and tech solutions.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton color="inherit" size="small">
                <Facebook />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Twitter />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Instagram />
              </IconButton>
              <IconButton color="inherit" size="small">
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink component={Link} to="/" color="inherit" underline="hover">
                Home
              </MuiLink>
              <MuiLink component={Link} to="/products" color="inherit" underline="hover">
                Products
              </MuiLink>
              <MuiLink component={Link} to="/categories" color="inherit" underline="hover">
                Categories
              </MuiLink>
              <MuiLink component={Link} to="/track-order" color="inherit" underline="hover">
                Track Order
              </MuiLink>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Categories
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink component={Link} to="/products?category=computer-accessories" color="inherit" underline="hover">
                Computer Accessories
              </MuiLink>
              <MuiLink component={Link} to="/products?category=storage-devices" color="inherit" underline="hover">
                Storage Devices
              </MuiLink>
              <MuiLink component={Link} to="/products?category=gaming" color="inherit" underline="hover">
                Gaming
              </MuiLink>
              <MuiLink component={Link} to="/products?category=mobile-accessories" color="inherit" underline="hover">
                Mobile Accessories
              </MuiLink>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn fontSize="small" />
                <Typography variant="body2">123 Tech Street, City</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone fontSize="small" />
                <Typography variant="body2">+1 234 567 8900</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email fontSize="small" />
                <Typography variant="body2">info@electronicsshop.com</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.2)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2">
            © {currentYear} Network Computers. All Rights Reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <MuiLink color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Privacy Policy
            </MuiLink>
            <MuiLink color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Terms & Conditions
            </MuiLink>
            <MuiLink color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Refund & Return
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
